import { suite, tools } from "@perprotocol/catalog";

export const brand = {
  organization: suite.domain,
  suite: suite.domain,
  product: tools.ctcae.name,
  tagline: "Search symptoms, diagnoses, and labs, compare exact criteria, and verify every result against the source.",
} as const;
